<section class="mat-typography" fxFlexFill fxLayout="column" style="position: relative;">
    <nav mat-tab-nav-bar style="background-color: #385A4C;" id="top-navbar">
        <div style="width: 80%; margin:0 auto;" fxLayoutAlign="start end">
            <a mat-tab-link *ngIf="loggedIn()" [routerLink]="'dashboard'" [active]="isActive('dashboard')">
        Dashboard
      </a>
            <a mat-tab-link *ngIf="loggedIn()" [routerLink]="'planning'" [active]="isActive('plan')">
        Planning
      </a>
            <span (click)="showPopover()" [mdePopoverTriggerFor]="offlineGroupPopover" mdePopoverTriggerOn="offlineTabTrigger">
      <a mat-tab-link *ngIf="loggedIn()"
         [routerLink]="'management'"
         [active]="isActive('management')"
         [disabled]="!isOnline">
        Group Management
      </a>
      </span>
            <span (click)="showPopover()" [mdePopoverTriggerFor]="explorePopover" mdePopoverTriggerOn="offlineTabTrigger">
        <a mat-tab-link *ngIf="loggedIn()"
          [routerLink]="'explore'"
          [active]="isActive('explore')"
          [disabled]="!isOnline">
          Explore
        </a>
      </span>
            <span *ngIf="canEditExercises()" (click)="showPopover()" [mdePopoverTriggerFor]="exerciseProgramPopover" mdePopoverTriggerOn="offlineTabTrigger">
        <a mat-tab-link *ngIf="loggedIn()"
          [routerLink]="'exercise-program'"
          [active]="isActive('exercise-program')"
          [disabled]="!isOnline">
          Exercise Program
        </a>
      </span>
            <a mat-tab-link [style.float]="loggedIn() ? 'right' : ''" *ngIf="!loggedIn()" [active]="isActive('login')">
        Login
      </a>
            <span fxFlex></span>
            <sync-status *ngIf="loggedIn()"></sync-status>

            <mat-slide-toggle class="toggle-offline" *ngIf="loggedIn()" [checked]="!isOnline" [disabled]="!navigatorOnline" (change)="forceToggleOffline()">
                Offline Mode: {{ isOnline ? "OFF" : "ON" }}
            </mat-slide-toggle>
            <mat-icon class="toggle-offline help" *ngIf="loggedIn()" [mdePopoverTriggerFor]="offlineTogglePopover" mdePopoverTriggerOn="click">
                help
            </mat-icon>

            <app-nav-user-menu [currentUser]="authService.currentUserObs | async" [offlinePlanPopover]="offlinePlanPopover"></app-nav-user-menu>

        </div>
    </nav>

    <div *ngIf="!currentUser && (backgroundImg < 1)" class="background-1" fxFlex>
        <router-outlet></router-outlet>
    </div>
    <div *ngIf="!currentUser && (backgroundImg >= 1)" class="background-2" fxFlex>
        <router-outlet></router-outlet>
    </div>
    <div *ngIf="currentUser" class="container" fxFlex>
        <router-outlet></router-outlet>
    </div>
    <div class="print-layout">
        <router-outlet name="print"></router-outlet>
    </div>

</section>

<mde-popover #offlineTogglePopover="mdePopover" mdePopoverPositionY="below" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="true">
    <mat-card style="max-width: 300px">
        <mat-card-content>
            <p>Manually set FitForce Planner to work in Offline Mode.</p>
            <p>This is useful for when you're on Internet connections with poor connectivity.</p>
            <p>{{ offline.offlineReason }}</p>
        </mat-card-content>
        <mat-card-actions>
            <div fxFlex></div>
            <button mat-button mat-button-raised>Close</button>
        </mat-card-actions>
    </mat-card>
</mde-popover>

<mde-popover #offlinePlanPopover="mdePopover" mdePopoverPositionY="below" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="true">
    <mat-card style="max-width: 300px">
        <mat-card-content>
            <p>Working in <span class="status-text-offline">OFFLINE</span> mode.</p>
            <p>Your plans and changes will be saved locally and synced once an Internet connection is established.</p>
        </mat-card-content>
    </mat-card>
</mde-popover>

<mde-popover #offlineGroupPopover="mdePopover" mdePopoverPositionY="above">
    <mat-card style="max-width: 300px">
        <mat-card-content>
            <p>Working in <span class="status-text-offline">OFFLINE</span> mode.</p>
            <p>Group management features will become available once you establish an Internet connection.</p>
        </mat-card-content>
        <mat-card-actions>
            <div fxFlex></div>
            <button mat-button mat-button-raised>Close</button>
        </mat-card-actions>
    </mat-card>
</mde-popover>

<mde-popover #explorePopover="mdePopover" mdePopoverPositionY="below">
    <mat-card style="max-width: 300px">
        <mat-card-content>
            <p>Working in <span class="status-text-offline">OFFLINE</span> mode.</p>
            <p>Explore feature will become available once you establish an Internet connection.</p>
        </mat-card-content>
        <mat-card-actions>
            <div fxFlex></div>
            <button mat-button mat-button-raised>Close</button>
        </mat-card-actions>
    </mat-card>
</mde-popover>

<mde-popover #exerciseProgramPopover="mdePopover" mdePopoverPositionY="below">
    <mat-card style="max-width: 300px">
        <mat-card-content>
            <p>Working in <span class="status-text-offline">OFFLINE</span> mode.</p>
            <p>Exercise Program feature will become available once you establish an Internet connection.</p>
        </mat-card-content>
        <mat-card-actions>
            <div fxFlex></div>
            <button mat-button mat-button-raised>Close</button>
        </mat-card-actions>
    </mat-card>
</mde-popover>

<div class="version-num">
    Ver {{version}}
</div>
<ngx-guided-tour></ngx-guided-tour>
